import { render, staticRenderFns } from "./multiple-brand-toggle.vue?vue&type=template&id=78821f52&scoped=true"
import script from "./multiple-brand-toggle.vue?vue&type=script&lang=js"
export * from "./multiple-brand-toggle.vue?vue&type=script&lang=js"
import style0 from "./multiple-brand-toggle.vue?vue&type=style&index=0&id=78821f52&prod&lang=css"
import style1 from "./multiple-brand-toggle.vue?vue&type=style&index=1&id=78821f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78821f52",
  null
  
)

export default component.exports